import { BaseBenefitPlanPolicyPeriod } from "@platform/openapi-types";

import { createContextConditionalEditable } from "../../../components/PlanEditor/utilities/agGridUtils";

import { createDisabledAwareTextFormatter } from "./formatters";

import type { CellSpec } from "./types";

export const currentCarrierName: CellSpec = {
  cellType: "text",
  dataType: "string",
  cellEditor: "agTextCellEditor",
  description:
    "Current carrier name (disabled if policy period is new or alternate)",
  editable: createContextConditionalEditable("policyPeriod", [
    BaseBenefitPlanPolicyPeriod.newBusiness,
    BaseBenefitPlanPolicyPeriod.alternate,
  ]),
  valueFormatter: createDisabledAwareTextFormatter(),
  validation: {
    required: false,
    maxLength: 1098,
  },
};

export const text: CellSpec = {
  cellType: "text",
  dataType: "string",
  cellEditor: "agTextCellEditor",
  description: "General text field",
  validation: {
    required: false,
    maxLength: 255,
  },
};

export const textArea: CellSpec = {
  cellType: "text",
  dataType: "string",
  cellEditor: "agLargeTextCellEditor",
  popup: true,
  cellEditorParams: {
    maxLength: 4096,
  },
  description: "Large text area with popup editor",
  validation: {
    required: false,
    maxLength: 4096,
  },
};

export const networkName: CellSpec = {
  cellType: "text",
  dataType: "string",
  cellEditor: "agTextCellEditor",
  description: "Network name",
  validation: {
    required: false,
    maxLength: 255,
  },
};

export const longText: CellSpec = {
  cellType: "text",
  dataType: "string",
  cellEditor: "agLargeTextCellEditor",
  popup: true,
  description: "Long text field",
};
